module.exports = __webpack_public_path__ + "static/img/pCT2.9787450f.png";